/**
 * @generated SignedSource<<578e57fa9c875d0c8c6ace3e99c1812c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AutoimmuneDisease = "NO" | "NOT_SPECIFIED" | "UNKNOWN" | "YES";
export type Cancer = "NO" | "NOT_SPECIFIED" | "UNKNOWN" | "YES";
export type Diabetes = "NO" | "NOT_SPECIFIED" | "UNKNOWN" | "YES_DIABETES_TYPE_ONE" | "YES_DIABETES_TYPE_ONE_AND_TWO" | "YES_DIABETES_TYPE_TWO";
export type HeartDisease = "NO" | "NOT_SPECIFIED" | "UNKNOWN" | "YES";
import { FragmentRefs } from "relay-runtime";
export type FamilyHistoryFragment$data = {
  readonly autoimmuneDisease: AutoimmuneDisease;
  readonly cancer: Cancer;
  readonly comment: string | null;
  readonly diabetes: Diabetes;
  readonly heartDisease: HeartDisease;
  readonly id: string;
  readonly " $fragmentType": "FamilyHistoryFragment";
};
export type FamilyHistoryFragment$key = {
  readonly " $data"?: FamilyHistoryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FamilyHistoryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FamilyHistoryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "autoimmuneDisease",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "heartDisease",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "diabetes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "comment",
      "storageKey": null
    }
  ],
  "type": "FamilyHistory",
  "abstractKey": null
};

(node as any).hash = "83b4ce476cc2a83d442e3c500a78cc30";

export default node;
